import React from "react";
import moment from "moment";
import DrugItem from "../components/DrugItem";
import { useTranslation } from "react-i18next";

const styles = {
  containerStyle: {
    marginBottom: 20,
  },
  titleStyle: {
    fontSize: 14,
    fontWeight: 700,
    color: "#333333",
    marginBottom: 5,
  },
  dateStyle: {
    fontSize: 10,
    color: "#999999",
  },
};

const DrugsContainer = ({ prescriptions }) => {
  const { t } = useTranslation(["consultations", "common"]);
  if (!prescriptions) return null;

  return (
    <div style={styles.containerStyle}>
      <p style={styles.titleStyle}>
        {t("prescriptionItems")} - {prescriptions.prescription_drugs.length}
      </p>
      <p style={styles.dateStyle}>
        {t("on", { ns: "common" })}{" "}
        {moment(prescriptions.created_at).format("DD/MM/YYYY")}
      </p>
      {prescriptions.prescription_drugs.map((drug, index) => (
        <DrugItem prescriptionDrug={drug} key={index} />
      ))}
    </div>
  );
};

export default DrugsContainer;
